import Keycloak from "keycloak-js";

const initOptions = {
    onLoad: "check-sso",
    checkLoginIframe: false
}

const keycloakInstance = new Keycloak("/keycloak.json");

const init = () => {
    return keycloakInstance.init(initOptions);
}

export default keycloakInstance;
export {init}
